import React from "react";
import ReactGiphySearchbox from "react-giphy-searchbox";
import useStyles from "./styles";
import { GIPHY_API_KEY } from "../../../constants";

const GifSearchBox = (props) => {
  const classes = useStyles();
  const inputProps = { ...props };
  return (
    <div className={classes.root}>
      <ReactGiphySearchbox {...inputProps} apiKey={GIPHY_API_KEY} />
    </div>
  );
};

export default GifSearchBox;
